import { DateTime } from 'luxon'
import { CampProps } from '../interfaces'
import moment from 'moment'

export interface IReportFilterOption {
  label: string
  start_date: DateTime
  end_date: DateTime
}

export const getReportIntervalOptions = (camp: CampProps, todayDate: DateTime) => {
  const intervalOptions: IReportFilterOption[] = [
    {
      label: 'Custom',
      start_date: null,
      end_date: null,
    },
    {
      label: 'Today',
      start_date: todayDate,
      end_date: todayDate,
    },
    {
      label: 'Last 7 days',
      start_date: todayDate.minus({ days: 7 }),
      end_date: todayDate,
    },
    {
      label: 'Last 4 weeks',
      start_date: todayDate.minus({ days: 28 }),
      end_date: todayDate,
    },
    {
      label: 'Last 3 months',
      start_date: todayDate.minus({ months: 3 }),
      end_date: todayDate,
    },
    {
      label: 'Last 12 months',
      start_date: todayDate.minus({ months: 12 }),
      end_date: todayDate,
    },
    {
      label: 'Month to date',
      start_date: todayDate.startOf('month'),
      end_date: todayDate,
    },
    {
      label: 'Quarter to date',
      start_date: todayDate.startOf('quarter'),
      end_date: todayDate,
    },
    {
      label: 'Year to date',
      start_date: todayDate.startOf('year'),
      end_date: todayDate,
    },
    {
      label: 'All time',
      start_date: DateTime.fromISO(camp.created_at as unknown as string),
      end_date: todayDate,
    },
  ]

  const intervalOptionsMonthly: IReportFilterOption[] = [
    {
      label: 'Custom',
      start_date: null,
      end_date: null,
    },
    ...Array.from({ length: 12 }, (_, i) => {
      const startOfMonth = todayDate.set({ month: i + 1 }).startOf('month');
      const endOfMonth = todayDate.set({ month: i + 1 }).endOf('month');
      return {
        label: startOfMonth.toFormat('MMMM'),
        start_date: startOfMonth,
        end_date: endOfMonth,
      };
    }),
  ];

  return {
    intervalOptions,
    intervalOptionsMonthly,
  }
}

export const rentRollOptions = Array.from({ length: 18 }, (_, i) => {
  const date = DateTime.now().minus({ months: 6 }).plus({ months: i });
  const label = date.year === DateTime.now().year 
    ? date.toFormat('MMMM')
    : date.toFormat('MMMM yyyy');
  
  return {
    label,
    start_date: date.startOf('month').startOf('day'),
    end_date: date.startOf('month').endOf('day')
  };
});
